// ========== PrivacyPage.jsx ==========
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './StaticPages.css';

const PrivacyPage = () => {
  const navigate = useNavigate();

  return (
    <div className="static-page">
      <header className="static-header">
        <nav className="static-nav">
          <div className="logo" onClick={() => navigate('/')}> Mellodai</div>
          <a onClick={() => navigate('/')}> Back to Home</a>
        </nav>
      </header>

      <div className="content-container">
        <div className="hero" style={{padding: '80px 2rem 40px', marginTop: 0}}>
          <h1>Privacy Policy</h1>
          <p>Your privacy and trust are our highest priority</p>
        </div>

        <div className="content-section">
          <h2>1. Information We Collect</h2>
          <h3>A. User Input Data (Events)</h3>
          <p>We collect the specific, factual details of major life events you enter (event type, date, location/context). This data is the input for AI calculation.</p>
          <h3>B. Subscription/Payment Data</h3>
          <p>For paid services, we collect necessary billing information processed via secure third-party payment processors.</p>
        </div>

        <div className="content-section">
          <h2>2. What We DO NOT Collect</h2>
          <div style={{background: 'rgba(168, 85, 247, 0.15)', padding: '1.5rem', borderRadius: '10px', borderLeft: '4px solid var(--primary)'}}>
            <p style={{fontWeight: 'bold', marginBottom: '1rem'}}>To ensure maximum privacy and prevent bias:</p>
            <ul>
              <li>We DO NOT use or store your name, email, or exact date of birth as AI learning features</li>
              <li>We DO NOT save or store prediction results after display</li>
            </ul>
          </div>
        </div>

        <div className="content-section">
          <h2>3. How We Use Information</h2>
          <ul>
            <li><strong>We don't collect cookies:</strong> For now, we proud that we don't use cookies to collect any user data</li>
            <li><strong>Service Provision:</strong> Input used only for real-time, one-time calculation</li>
            <li><strong>Model Improvement:</strong> Anonymized, aggregated data used to train the Neural Network</li>
            <li><strong>Communication:</strong> Contact info used only for service announcements and support</li>
          </ul>
        </div>

        <div className="content-section">
          <h2>4. Data Security</h2>
          <p>We implement commercially reasonable security measures to protect data in transit and during calculation.</p>
          <p style={{fontStyle: 'italic', marginTop: '1rem'}}>However, no method of transmission over the Internet is 100% secure. We cannot guarantee absolute security.</p>
        </div>

        <div className="content-section">
          <h2>5. Your Rights</h2>
          <ul>
            <li>Access your personal data</li>
            <li>Request correction of inaccurate data</li>
            <li>Request deletion of your account</li>
            <li>Opt-out of data contribution (paid users)</li>
            <li>Export your data in portable format</li>
          </ul>
          <p>Contact: privacy@mellodai.com</p>
        </div>

        <div className="content-section">
          <p style={{textAlign: 'center', fontStyle: 'italic', color: 'var(--textLight)'}}>Last Updated: November 1, 2025</p>
        </div>
      </div>

      <footer className="static-footer">
        <p>&copy; 2025 Mellodai. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default PrivacyPage;
